import React, { PureComponent } from 'react'
import { sum, values } from 'lodash-es'
import moment from 'moment-timezone'
import CollectionSection from './sections/CollectionSection'
import GoalsSection from './sections/GoalsSection'
import HeaderSection from './sections/HeaderSection'
import PlatformsSection from './sections/PlatformsSection'
import PledgeSection from './sections/PledgeSection'
import ExchangeHelper from './utils/exchangeHelper'
import './assets/styles/shared/app.css'

class App extends PureComponent {
  state = {
    coins: [
      { ticker: 'BTC', address: '3BhCk26zvGUbYMvdWVaUdEg72CGBmuMwQ1' },
      {
        ticker: 'XMY',
        address: '4hPbifemLExWBGhgytPnnez8jrygFawbkt',
      },
    ],
    balances: {
      BTC: 0.0,
      XMY: 0.0,
    },
    endDate: moment.tz('2019-06-15 12:00', 'Europe/Belgium'),
    pledged: 0,
    goal: 2,
    goals: [
      {
        amount: 0.8,
        title: 'Earth',
        includes: ['Myriad Coin Terminal', 'Myriad Coin Debit Card'],
      },
      {
        amount: 2,
        title: 'Space',
        includes: ['App for payments' ,'Free Debit Cards for pledgers', 'Getting listed on Binance (if possible)'],
      },
    ],
  }

  insights = {
    BTC: 'https://btc-blockbook1.coinid.org',
    XMY: 'https://xmy-blockbook1.coinid.org',
  }

  exchangeHelpers = {}

  componentDidMount() {
    const { coins } = this.state
    coins.map((coin) => {
      const { address, ticker } = coin

      if (ticker !== 'BTC') {
        this.exchangeHelpers[ticker] = ExchangeHelper(ticker)
      }

      return this.fetchAddressBalance({ address, ticker })
    })
  }

  convertToBTC = (ticker, balance) => this.exchangeHelpers[ticker].convert(balance, 'BTC')

  fetchAddressBalance = ({ address, ticker }) => {
    const requests = [
      fetch(`${this.insights[ticker]}/api/address/${address}`),
    ]

    Promise.all(requests)
      .then(responses => Promise.all(responses.map(res => res.json())))
      .then((balances) => {
        const total = sum(balances.map(balance => Number(balance.balance)))
        return ticker !== 'BTC' ? this.convertToBTC(ticker, total) : total
      })
      .then((btcValue) => {
        const { balances } = this.state
        const newBalances = Object.assign({}, balances)
        newBalances[ticker] = btcValue

        let pledged = sum(values(newBalances))

        if (pledged <= 0.0) {
          pledged = 0.0
        }
        this.setState({ balances: newBalances, pledged })
      })
      .catch(error => console.log(error))
  }

  render() {
    const {
      coins, endDate, goal, goals, pledged,
    } = this.state

    return (
      <div className="wrapper">
        <HeaderSection />
        <PledgeSection goal={goal} pledged={pledged} endDate={endDate} />
        <GoalsSection goals={goals} pledged={pledged} />
        <PlatformsSection />
        <CollectionSection coins={coins} insights={this.insights} />
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js